export enum ErrorStatusCodeEnum {
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	Internal = 500,
	ServiceUnavailable = 503,
}
